import styled from '@emotion/styled'
import { css, keyframes } from '@emotion/react'
import { CloseButton } from '@leroy-merlin-br/backyard-react-ui'

const COLOR_MAP = {
  default: {
    color: 'n900',
    background: 'n100',
    borderColor: 'n200'
  },
  success: {
    color: 'p900',
    background: 'p100',
    borderColor: 'p200'
  },
  danger: {
    color: 'r900',
    background: 'r100',
    borderColor: 'r200'
  },
  warning: {
    color: 'y900',
    background: 'y100',
    borderColor: 'y200'
  }
}

const wrapperStyles = ({ theme }) => css`
  label: notification;

  display: flex;

  border-radius: ${theme.borderRadius.tera};
  border-width: 1px;
  border-style: solid;
`

const wrapperColorStyles = ({ theme, color }) => {
  const currentColor = COLOR_MAP[color]

  return css`
    label: notification--${color};

    color: ${theme.colors[currentColor.color]};
    background: ${theme.colors[currentColor.background]};
    border-color: ${theme.colors[currentColor.borderColor]};
  `
}

const wrapperAnimatingStyles = ({ animating = false }) => {
  if (!animating) {
    return null
  }

  const closeAnimation = keyframes`
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  `

  return css`
    label: notification--animating;

    animation: ${closeAnimation} 0.3s ease-in-out forwards;
  `
}

const textWrapperStyles = ({ theme }) => css`
  label: notification__text;

  margin: ${theme.spacings.byte};
  margin-left: ${theme.spacings.bit};
`

const buttonStyles = ({ theme }) => css`
  label: notification__button;

  right: 0;
  margin: ${theme.spacings.bit};
  padding: ${theme.spacings.byte};

  svg {
    height: 12px;
    width: 12px;
  }
`

const iconWrapperStyles = ({ theme }) => css`
  label: notification__icon;

  display: flex;
  margin: ${theme.spacings.byte};
`

export const Wrapper = styled('div')(wrapperStyles, wrapperColorStyles, wrapperAnimatingStyles)
export const TextWrapper = styled('div')(textWrapperStyles)
export const Button = styled(CloseButton)(buttonStyles)
export const IconWrapper = styled('div')(iconWrapperStyles)
